import { AllowListPhoneNumberFragment } from '@occc/graphql';
import { readableDate } from '@occc-app/lib/format';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MakeTableFields } from '@occc/ui-design-system';

import { AllowListActionsContainer } from './allow-list.actions.container';

export const makeFields: MakeTableFields<{
  item: AllowListPhoneNumberFragment;
  isUserPermittedToEdit: boolean;
  isUserPermittedToDelete: boolean;
  openUpsertAllowListPhoneNumberModal: (params: {
    isCreateMode: boolean;
    entity?: AllowListPhoneNumberFragment;
  }) => void;
}> = ({
  item,
  isUserPermittedToEdit,
  isUserPermittedToDelete,
  openUpsertAllowListPhoneNumberModal,
}) => [
  { label: 'Member Name', value: item.name, width: '20%' },
  {
    label: 'Phone Number',
    value: formatPhoneNumberNationalForUS(item.phoneNumber) || item.name,
    width: '20%',
  },
  { label: 'Entered Date', value: readableDate(item.createdAt), width: '20%' },
  { label: 'Reason', value: item.reason, width: '40%' },
  {
    label: 'actions',
    value: (
      <AllowListActionsContainer
        uuid={item.uuid}
        name={formatPhoneNumberNationalForUS(item.phoneNumber) || item.name}
        isUserPermittedToEdit={isUserPermittedToEdit}
        isUserPermittedToDelete={isUserPermittedToDelete}
        onEditClick={() =>
          openUpsertAllowListPhoneNumberModal({ entity: item, isCreateMode: false })
        }
      />
    ),
    padding: 'button',
    align: 'right',
  },
];
